export default "__VITE_ASSET__B_j8$ldh__"